"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethods = exports.PaymentLogsDirection = exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["init"] = "init";
    PaymentStatus["completed"] = "completed";
    PaymentStatus["refundRequested"] = "refundRequested";
    PaymentStatus["refunded"] = "refunded";
    PaymentStatus["partialRefunded"] = "partialRefunded";
    PaymentStatus["error"] = "error";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var PaymentLogsDirection;
(function (PaymentLogsDirection) {
    PaymentLogsDirection["outgoing"] = "outgoing";
    PaymentLogsDirection["incoming"] = "incoming";
})(PaymentLogsDirection || (exports.PaymentLogsDirection = PaymentLogsDirection = {}));
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["tinkoff"] = "tinkoff";
    PaymentMethods["mandarin"] = "mandarin";
    PaymentMethods["stripe"] = "stripe";
})(PaymentMethods || (exports.PaymentMethods = PaymentMethods = {}));
//# sourceMappingURL=payments.enum.js.map